import axios from "axios";
import { API } from "./api";

// Separate axios instance for customer portal endpoints
// (customer token is stored under a different key so it doesn't clash with admin token)
const customerApi = axios.create({ baseURL: API });

customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("svrm_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default customerApi;
